import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

// Theme
import theme from "./theme/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"

//Company
import Company from "./company/reducer"

//Document
import Documents from "./documents/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  account: Account,
  ForgetPassword,
  Profile,
  theme,
  Dashboard,
  Company,
  Documents
})

export default rootReducer
